import {
	Component,
	ElementRef,
	Inject,
	Input,
	LOCALE_ID,
	ViewChild,
} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PaymentRequestService } from '../../../services/payment-request.service';
import { MediaObserver } from '@angular/flex-layout';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { ShareFundraiserPageComponent } from '../share-dialog/share-fundraiser-page/share-fundraiser-page.component';
import { environment } from 'src/environments/environment';
import { SafeHtml } from '@angular/platform-browser';
import { MediaService } from '../../../services/media.service';
import { EmbedPreview } from '../../../models/embedPreview';
import { ThemeService } from 'src/app/global/services/theme.service';
import { FundraiserService } from '../../../services/fundraiser.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { DonationProgressBarComponent } from '../../../../../shared/components/fundraiser-card/shared/donation-progress-bar/donation-progress-bar.component';
import { AmountViewComponent } from '../../../../../shared/components/fundraiser-card/shared/amount-view/amount-view.component';
import { MatCardModule } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout/flex';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgIf, NgTemplateOutlet, NgSwitch, NgSwitchCase, NgSwitchDefault, NgStyle, NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-share-preview',
    templateUrl: './share-preview.component.html',
    styleUrls: ['./share-preview.component.scss'],
    standalone: true,
    imports: [NgIf, ExtendedModule, FlexModule, NgTemplateOutlet, NgSwitch, NgSwitchCase, NgSwitchDefault, MatCardModule, NgStyle, AmountViewComponent, DonationProgressBarComponent, MatTabsModule, MatButtonModule, MatDividerModule, NgClass, MatFormFieldModule, DecimalPipe]
})
export class SharePreviewComponent {
	@Input() type: string | any = '';
	@Input() preview: boolean = false;
	@Input() profileResponse: any;
	@Input() slug: any;
	shareLink: string = '';
	oneTimeLabel = $localize`:@@embed_oneTimeLabel:One Time`;
	monthlyLabel = $localize`:@@embed_monthlyLabel:Monthly`;
	yearlyLabel = $localize`:@@embed_yearlyLabel:Yearly`;
	matTooltip = $localize`:@@share_fundraiser_tooltip_copy:Copy share fundraiser link`;
	currency_symbol: string = '';
	onetime_first: string = '';
	onetime_second: string = '';
	onetime_third: string = '';
	onetime_forth: string = '';
	monthly_first: string = '';
	monthly_second: string = '';
	monthly_third: string = '';
	monthly_forth: string = '';
	yearly_first: string = '';
	yearly_second: string = '';
	yearly_third: string = '';
	yearly_forth: string = '';
	fundraiserBackgroundImage: string = '';
	fundraiserBackgroundVideo: string = '';
	video: string = '';
	youtubeThumbnail: any;
	videoPath!: any;
	selectedAmount: string | undefined;
	embedPreviewData: EmbedPreview | undefined;
	boxShadow: string =
		'0 2px 1px -1px #0003, 0 1px 1px #00000024, 0 1px 3px #0000001f';

	@Input() amountProgressData!: any;
	@ViewChild('embedView', { static: true }) embedView!: ElementRef;
	previewSwitchCase: string = 'donation-widget';
	constructor(
		public router: Router,
		public dialog: MatDialog,
		public paymentRequest: PaymentRequestService,
		public media: MediaObserver,
		public _accountService: AccountService,
		public _mediaService: MediaService,
		private _themeService: ThemeService,
		private fundraiserService: FundraiserService,
		@Inject(LOCALE_ID) public locale: string,
		@Inject(MAT_DIALOG_DATA) public data: { fundraiser: any },
		public dialogRef: MatDialogRef<ShareFundraiserPageComponent>
	) {
		this.locale = this._accountService.getLocaleId();
	}

	ngOnInit(): void {
		this.currency_symbol = this.data?.fundraiser?.currency_symbol;
		this.onetime_first =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_first;
		this.onetime_second =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_second;
		this.onetime_third =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_third;
		this.onetime_forth =
			this.data?.fundraiser?.custom_donation_configuration?.onetime_forth;
		this.monthly_first =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_first;
		this.monthly_second =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_second;
		this.monthly_third =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_third;
		this.monthly_forth =
			this.data?.fundraiser?.custom_donation_configuration?.monthly_forth;
		this.yearly_first =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_first;
		this.yearly_second =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_second;
		this.yearly_third =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_third;
		this.yearly_forth =
			this.data?.fundraiser?.custom_donation_configuration?.yearly_forth;
		if (
			(this.data?.fundraiser?.background?.image != '' &&
				this.data?.fundraiser?.background?.video != '') ||
			(this.data?.fundraiser?.background?.image == '' &&
				this.data?.fundraiser?.background?.video != '') ||
			(this.data?.fundraiser?.background?.image != '' &&
				this.data?.fundraiser?.background?.video == '')
		) {
			this.fundraiserBackgroundImage = this.data?.fundraiser?.background?.image;
			this.fundraiserBackgroundVideo = this.data?.fundraiser?.background?.video;
		} else {
			this.fundraiserBackgroundImage =
				this.data?.fundraiser?.parent?.background?.image;
			this.fundraiserBackgroundVideo =
				this.data?.fundraiser?.parent?.background?.video;
		}
		const url: any = this.fundraiserBackgroundVideo;
		this.youtubeThumbnail = this.checkVideoUrl(url);
		this.videoPath = url;

		if (this.type == 'donate') {
			let splitted = this.router.url.split('/');
			this.shareLink =
				environment.homeUrl +
				'/' +
				this._accountService.getLocaleId() +
				'/' +
				this.type +
				'/' +
				splitted[2];
		} else if (this.type == 'fundraiser') {
			let splitted = this.router.url.split('/');
			this.shareLink =
				environment.homeUrl +
				'/' +
				this._accountService.getLocaleId() +
				'/' +
				splitted[1] +
				'/' +
				splitted[2];
			this.router.url;
		} else {
			this.paymentRequest.currentCustomText.subscribe((data) => {
				this.shareLink = data;
			});
		}

		this.paymentRequest.currentCustomAmount.subscribe((data) => {
			this.selectedAmount = data;
		});

		this._accountService.getWidgetCheckbox().subscribe((widgetType: any) => {
			this.previewSwitchCase = widgetType;
		});

		this.fundraiserService
			.getFundraiserBySlug(this.slug, this.locale)
			.subscribe((data: any) => {
				this.profileResponse = data?.data?.result;

				this._themeService.setTheme(
					this.profileResponse?.profile?.primary_color,
					this.profileResponse?.profile?.secondary_color,
					this.profileResponse?.profile?.fonts
				);

				this._mediaService.updateEmbedPreview(
					this.profileResponse?.profile?.card_shadow,
					this.profileResponse?.profile?.primary_color,
					this.profileResponse?.profile?.secondary_color,
					this.profileResponse?.profile?.fonts,
					this.profileResponse?.profile?.button_radius
				);
			});
		this._mediaService.currentcustomEmbedPreview.subscribe(
			(embedPreview: EmbedPreview) => {
				if (embedPreview) {
					this.embedPreviewData = embedPreview;

					this._themeService.setTheme(
						this.embedPreviewData.primaryColor,
						this.embedPreviewData.secondaryColor,
						this.embedPreviewData.fontFamily
					);
					this.boxShadow = this.boxShadowSet(
						this.embedPreviewData.boxShadowLevel
					);
				}
			}
		);
	}

	ngOnDestroy() {
		if (this.profileResponse) {
			this._themeService.setTheme(
				this.profileResponse?.profile?.primary_color,
				this.profileResponse?.profile?.secondary_color,
				this.profileResponse?.profile?.fonts
			);
		}
	}

	boxShadowSet(value: any) {
		let newBoxShadow = '';

		switch (value) {
			case 1:
				newBoxShadow =
					'0 2px 1px -1px #0003, 0 1px 1px #00000024, 0 1px 3px #0000001f';
				break;
			case 2:
				newBoxShadow =
					'0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f';
				break;
			case 4:
				newBoxShadow =
					'0 2px 4px -1px #0003, 0 4px 5px #00000024, 0 1px 10px #0000001f';
				break;
			default:
				newBoxShadow =
					'0 2px 1px -1px #0003, 0 1px 1px #00000024, 0 1px 3px #0000001f';
		}
		return newBoxShadow;
	}

	/* INFO: set Image Base URL */
	checkVideoUrl(url: any): SafeHtml {
		const vimeoId = this.getVideoIdFromLink(
			url,
			/^https?:\/\/(?:www\.)?vimeo\.com\/(\d+)/
		);
		const youtubeId = this.getVideoIdFromLink(
			url,
			/^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|watch\?v=|v\/|shorts\/)|youtu\.be\/)([\w\-]+)(?:\S+)?$/
		);

		if (vimeoId) {
			return `https://vumbnail.com/${vimeoId}.jpg`;
		} else if (youtubeId) {
			return `https://i.ytimg.com/vi/${youtubeId}/mqdefault.jpg`;
		} else {
			return 'unknown';
		}
	}

	getVideoIdFromLink(url: string, pattern: RegExp): string {
		const match = url?.match(pattern);
		return match && match[1] ? match[1] : '';
	}
}
